
import { Component, Inject, OnInit, ViewContainerRef, DOCUMENT } from '@angular/core';
import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthService } from './services/auth/auth.service';
import { HotjarService } from './services/hotjar/hotjar.service';
import { CcDialogService } from './services/ui/cc-dialog.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'Costa Coffee';
  loginURL = '';
  isLoginURL = false;
  previousUrl: string;

  constructor(
    public authService: AuthService,
    public router: Router,
    @Inject(DOCUMENT) private document: any,
    private hotjarService: HotjarService,
    private viewContainerRef: ViewContainerRef,
    private dialogService: CcDialogService,
  ) {
    const routesArray = ['login', 'error', '/callback', '/'];
    this.router.events.subscribe((event: Event) => {
      const tempUrl: any = (this.router.url).split('/');
      const cUrl = tempUrl[1].split('?');
      this.authService.currentRoute = cUrl[0];
      if (this.authService.currentRoute === '' || this.authService.currentRoute === 'login') {
        document.querySelector('html').classList.add('hide-scroll');
      } else {
        document.querySelector('html').classList.remove('hide-scroll');
      }
      if (this.authService.currentRoute.indexOf('notifications') != -1) {
        this.document.body.classList.add('abc');
      } else {
        this.document.body.classList.remove('abc');
      }
      if (event instanceof NavigationStart) {
        let currentUrlSlug = event.url.slice(1);
        this.previousUrl = currentUrlSlug;
        localStorage.setItem('previousUrl', this.router.url);
      }

      if (event instanceof NavigationEnd) {
        this.loginURL = event.url;
        const newRoute = event.url.split('/')[1].replace(/[?].*$/gm, '') || '/';
        if (routesArray.indexOf(newRoute) > -1) {
          this.isLoginURL = false;
        } else {
          this.isLoginURL = true;
        }
      }
    });
  }

  ngOnInit(): void {
    this.dialogService.registerContainerRef(this.viewContainerRef);
  }
}
